import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import SvgIcon from 'globalcomponents/SvgIcon/Base';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import ViewForm from './TopActions';
import { columns } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const LineChart = lazy(() => import(`globalcomponents/UI/Graph/LineGraph/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  apiStatus,
  callback,
  history,
  Styled,
  fetchTableData,
  chat,
  fetchChartData,
  tableData,
  chartData,
  driverList,
  vehicleListDropDown,
  vehicleList,
  topAction,
  fetchDriverBehaviorDetails,
  driverbehavior,
}) => {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const information = i18n.t('common.tableEmptyMessage');
  const isRishTheory = checkServiceProvider('component_isRishTheory', window?.$environment?.SERVICE_PROVIDER, false);

  const generateRows = () => {
    let data = tableData;
    data.forEach((ele) => {
      if (vehicleList) {
        ele.vechileName = vehicleList.filter((item) => ele.esn && item.esn == ele.esn)[0]?.name;
      }
      if (isRishTheory) {
        if (ele?.driverId) {
          ele.icon = <SvgIcon className="infoImg" value={mediaUrls.driverbehavior} />;
        } else if (ele?.esn) {
          ele.icon = <SvgIcon className="infoImg" value={mediaUrls.vehicleBehaviour} />;
        }
      }
    });
    return data || [];
  };

  return (
    <Styled.Wrapper>
      <Styled.TopWrapper>
        {topAction && (
          <ViewForm
            apiStatus={apiStatus}
            history={history}
            callback={callback}
            Styled={Styled}
            driverList={driverList}
            fetchTableData={fetchTableData}
            fetchChartData={fetchChartData}
            fetchDriverBehaviorDetails={fetchDriverBehaviorDetails}
            vehicleListDropDown={vehicleListDropDown}
          />
        )}
      </Styled.TopWrapper>

      <div className="basicMeasures">
        <div className="chartContainer">
          {driverbehavior.chartSuccess && chartData && Object.keys(chartData.data).length !== 0 ? (
            <LineChart
              width={'470px'}
              height={'230px'}
              labels={chartData.labels}
              data={chartData.data}
              title={i18n.t('graphTitles.speeding')}
              history={history}
              theme={theme}
              displayLegend={false}
              noHyperLink
            ></LineChart>
          ) : (
            <div id="noData">
              <div id="nameWrap">
                <p>{i18n.t('graphTitles.speeding')}</p>
              </div>
              <div id="msgWrap">
                <p>{i18n.t('common.noDataToPlot')} </p>
              </div>
            </div>
          )}
        </div>
      </div>

      <Styled.TableWrapper>
        <Table
          type="client"
          title=""
          columns={[...columns]}
          data={generateRows()}
          emptyMessage={information}
          sizeOfPage={15}
          actions={[]}
          i18n={i18n}
          defaultSortBy={{ sortBy: 'count', order: 'desc' }}
        />
      </Styled.TableWrapper>
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  fetchViolations: PropTypes.func.isRequired,
  handleExportCsaViolations: PropTypes.func.isRequired,
};
